import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/facturacion/anticipos';
import Anticipo from './AnticipoList';


const ms2p = (state) => {
  return {
    ...state.anticipo_fac,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Anticipo);